import React from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import App from './App'
import Home from './admin';
import Artical from './pages/artical';
import ListArt from './pages/listart';
import ArtEdit from './pages/artical/edit'
export default class IRouter extends React.Component {

    render() {
        return (
            <HashRouter>
                <App>
                    <Switch>
                        {/* <Route path='/admin' component={Admin} /> */}
                        <Route exact path='/' render={() =>
                            <Home component={ListArt}>
                                <ListArt></ListArt>
                            </Home>
                        } />
                        <Route path='/home' render={() =>
                            <Home>
                                <Switch>
                                    <Route path='/home/list/:d?' component={ListArt} />
                                    <Route path='/home/artical/:artid' component={Artical}/>
                                    <Route path='/home/articaledit/:id?' component={ArtEdit} />
                                </Switch>
                            </Home>
                        } />
                    </Switch>
                </App>
            </HashRouter >
        );
    }
}
// ,
//   "proxy": "http://139.155.14.228:90"